"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = fetchEyebrowPromo;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _Logger = _interopRequireDefault(require("./util/Logger"));

var _Utils = _interopRequireDefault(require("./util/Utils"));

var _constants = require("../constants");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var loggerInstance = new _Logger.default('fetchEyebrowPromo');

function fetchEyebrowPromo(_x) {
  return _fetchEyebrowPromo.apply(this, arguments);
}

function _fetchEyebrowPromo() {
  _fetchEyebrowPromo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(eyebrowDcName) {
    var hostname, url, requestOptions, eyebrowPromo;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof window === 'undefined')) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            hostname = (0, _uigCurrentEnvironmentUtil.getHostname)('api2');
            url = "https://".concat(hostname, "/v1/services-dynamic-content/v1/dynamic-content?contentSpace=").concat(eyebrowDcName);
            requestOptions = {
              headers: {
                'SFly-Apikey': _Utils.default.getEnvPrefix() !== '' ? _constants.DC_SERVICE_API_KEYS.NON_PROD : _constants.DC_SERVICE_API_KEYS.PROD
              }
            };
            eyebrowPromo = '';
            _context.next = 8;
            return (0, _uigCdnLibraries.polyfillFetch)();

          case 8:
            _context.next = 10;
            return window.fetch(url, requestOptions).then(function (response) {
              return response.json();
            }).then(function (responseData) {
              eyebrowPromo = responseData.dynamicContent;
            }).catch(function (error) {
              loggerInstance.error('Error: while fetching eyebrowPromo', 'eyebrowPromo', error);
            });

          case 10:
            return _context.abrupt("return", eyebrowPromo && {
              __html: eyebrowPromo
            });

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchEyebrowPromo.apply(this, arguments);
}